<!-- =========================================================================================
    File Name: QuillEditorThemeBubble.vue
    Description: Quill editor with snow theme
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card title="Theme Bubble" code-toggler>
    <p class="mb-5">Bubble is a simple tooltip based theme</p>
    <quill-editor v-model="content" :options="editorOption"></quill-editor>

    <prism class="rounded-lg"> {{ content }} </prism>

    <template slot="codeContainer">
      &lt;template&gt; &lt;quill-editor v-model=&quot;content&quot;
      :options=&quot;editorOption&quot;&gt;&lt;/quill-editor&gt; &lt;/template&gt;
      &lt;script&gt; // require styles import 'quill/dist/quill.core.css' import
      'quill/dist/quill.snow.css' import 'quill/dist/quill.bubble.css' import {
      quillEditor } from 'vue-quill-editor' export default { data() { return {
      editorOption: { theme: 'bubble', }, content: "
      <p style="text-align: center">LAPORAN / BERITA ACARA</p>
      <p style="text-align: center">PENYERAHAN DAN PENYEMBELIHAN</p>
      <p style="text-align: center">HEWAN QURBAN 1443 H./ 2022 M.</p>
      <table border="1" cellpadding="2" cellspacing="0">
        <tbody>
          <tr>
            <td><p>Deskripsi Kegiatan</p></td>
            <td><p>:</p></td>
            <td>
              <p>
                <em
                  ><i><span>(Isi dengan deskripsi kegiatan)</span></i></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Program</p></td>
            <td><p>:</p></td>
            <td>
              <p>
                <em
                  ><i><span>(Isi dengan judul program)</span></i></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Hari/Tgl Pelaksanaan</p></td>
            <td><p>:</p></td>
            <td>
              <p>
                <em
                  ><i><span>(Isi dengan tanggal pelaksanaan qurban)</span></i></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Lokasi Pelaksanaan</p></td>
            <td><p>:</p></td>
            <td>
              <p>
                <em
                  ><i><span>(Isi dengan lokasi pelaksanaan qurban)</span></i></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Alamat</p></td>
            <td><p>:</p></td>
            <td>
              <p>
                <em
                  ><i
                    ><span
                      >(Isi dengan alamat detail dari lokasi pelaksanaan qurban)</span
                    ></i
                  ></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Koordinator Lokal</p></td>
            <td><p>:</p></td>
            <td>
              <p>
                <em
                  ><i
                    ><span
                      >(Isi dengan nama koordinator lokal dari pelaksanaan qurban)</span
                    ></i
                  ></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Nomor HP</p></td>
            <td><p>:</p></td>
            <td>
              <p>
                <em
                  ><i
                    ><span>(Isi dengan nomor telp/hp dari koordinator lokal)</span></i
                  ></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Jumlah/Jenis Hewan</p></td>
            <td><p>:</p></td>
            <td>
              <p>
                <em
                  ><i
                    ><span
                      >(Isi dengan jumlah hewan dan jenis hewan, contoh : 1/Kambing)</span
                    ></i
                  ></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Jumlah PM</p></td>
            <td><p>:</p></td>
            <td>
              <p>
                <em
                  ><i><span>(Isi dengan jumlah penerima manfaat)</span></i></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Dokumentasi Penerimaan</p></td>
            <td><p>:</p></td>
            <td>
              <p>
                <em
                  ><i
                    ><span
                      >(Isi dengan foto/video kegiatan penerimaan hewan qurban oleh
                      penyembelih)</span
                    ></i
                  ></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Dokumentasi Pemotongan</p></td>
            <td><p>&nbsp;:</p></td>
            <td>
              <p>
                <em
                  ><i
                    ><span
                      >(Isi dengan foto/video kegiatan penyembelihan hewan qurban)</span
                    ></i
                  ></em
                >
              </p>
            </td>
          </tr>
          <tr>
            <td><p>Dokumentasi Distribusi</p></td>
            <td><p>:&nbsp;</p></td>
            <td>
              <p>
                <em
                  ><i
                    ><span
                      >(Isi dengan foto/video kegiatan pendistrbusian daging ke para
                      penerima manfaat)</span
                    ></i
                  ></em
                >
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      ", } }, components: { quillEditor, } } &lt;/script&gt;
    </template>
  </vx-card>
</template>

<script>
// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import Prism from "vue-prism-component";

export default {
  data() {
    return {
      editorOption: {
        theme: "bubble",
      },
      content:
        "<p style='text-align: center;'>LAPORAN / BERITA ACARA</p><p style='text-align: center;'>PENYERAHAN DAN PENYEMBELIHAN</p><p style='text-align: center;'>HEWAN QURBAN 1443 H./ 2022 M.</p><table border='1' cellpadding='2' cellspacing='0'><tbody><tr><td><p>Deskripsi Kegiatan</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan deskripsi kegiatan)</span></i></em></p></td></tr><tr><td><p>Program</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan judul program)</span></i></em></p></td></tr><tr><td><p>Hari/Tgl Pelaksanaan</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan tanggal pelaksanaan qurban)</span></i></em></p></td></tr><tr><td><p>Lokasi Pelaksanaan</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan lokasi pelaksanaan qurban)</span></i></em></p></td></tr><tr><td><p>Alamat</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan alamat detail dari lokasi pelaksanaan qurban)</span></i></em></p></td></tr><tr><td><p>Koordinator Lokal</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan nama koordinator lokal dari pelaksanaan qurban)</span></i></em></p></td></tr><tr><td><p>Nomor HP</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan nomor telp/hp dari koordinator lokal)</span></i></em></p></td></tr><tr><td><p>Jumlah/Jenis Hewan</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan jumlah hewan dan jenis hewan, contoh : 1/Kambing)</span></i></em></p></td></tr><tr><td><p>Jumlah PM</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan jumlah penerima manfaat)</span></i></em></p></td></tr><tr><td><p>Dokumentasi Penerimaan</p></td><td><p>:</p></td><td><p><em><i><span>(Isi dengan foto/video kegiatan penerimaan hewan qurban oleh penyembelih)</span></i></em></p></td></tr><tr><td><p>Dokumentasi Pemotongan</p></td><td><p>&nbsp;:</p></td><td><p><em><i><span>(Isi dengan foto/video kegiatan penyembelihan hewan qurban)</span></i></em></p></td></tr><tr><td><p>Dokumentasi Distribusi</p></td><td><p>:&nbsp;</p></td><td><p><em><i><span>(Isi dengan foto/video kegiatan pendistrbusian daging ke para penerima manfaat)</span></i></em></p></td></tr></tbody></table>",
    };
  },
  components: {
    quillEditor,
    Prism,
  },
};
</script>
